"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");
/**
 * Find immediate child of an element
 *
 * @param type
 * @param props
 */


exports.findChild = function (type, props) {
  return exports.findChildren(type, props)[0];
};

exports.findChildren = function (type, props) {
  var children = props.children;
  var filtered = react_1.Children.toArray(children).filter(exports.filterChildrenWithType(type));
  return filtered;
};
/**
 *
 * @param type
 */


exports.filterChildrenWithType = function (type) {
  return function (child) {
    if (child && child.type === type) {
      return true;
    } // checks for Hot Loader


    if (child && child.type && child.type.name === "ProxyFacade" && child.type.__reactstandin__getCurrent) {
      var standInEl = child.type.__reactstandin__getCurrent();

      return standInEl === type;
    }

    return false;
  };
};